module.exports = __webpack_public_path__ + "static/media/blizzard-light.0145ec02.svg";